import React, { Component } from 'react';

import GlobalHelper from '../../../Common/Helpers/GlobalHelper';

//componentes
import ComboMenuProcesos from './ComboMenuProcesos';
import TableroProcesos from './TableroProcesos';
import ModalProcesos from './ModalProcesos';
import ModalProcesosDocumentados from './ModalProcesosDocumentados';
import ModalEjecucionDemanda from './ModalEjecucionDemanda';
import SelectorFecha from './SelectorFecha';
import DetalleErrores from './DetalleErrores/DetalleErrores';
import ModalEjecucionEnProcesos from './ModalEjecucionEnProcesos';
import ModalMensajeResultado from './ModalMensajeResultado';

class Procesos extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.cambiarDiaPorFlecha = this.cambiarDiaPorFlecha.bind(this);
        this.borrarFiltros = this.borrarFiltros.bind(this);
        this.mostrarModal = this.mostrarModal.bind(this);
        this.RecorrerTabla = this.RecorrerTabla.bind(this);
        this.limpiarCombos = this.limpiarCombos.bind(this);
    }

    limpiarCombos() {
        this.props.limpiarCombos();
    }

    RecorrerTabla() {
        this.props.RecorrerTabla();
    }

    componentDidMount() {
        $('[data-toggle="tooltip"]').tooltip();
        this.props.getScreenData(this.props.currentScope);
    }

    componentWillUnmount() {
        this.props.resetStore();
    }

    cambiarDiaPorFlecha(sentido) {
        let fechaActual;

        if (typeof this.props.data.fecha == 'object') fechaActual = this.props.data.fecha;
        else if (typeof this.props.data.fecha == 'string' && this.props.data.fecha.length > 10) fechaActual = new Date();
        else if (typeof this.props.data.fecha == 'string') fechaActual = GlobalHelper.ConvertirFecha(this.props.data.fecha);

        let fecha2;

        if (sentido == 'anterior') {
            fecha2 = new Date(fechaActual.setDate(fechaActual.getDate() - 1));
        } else {
            //SI SE ESTÝ TRATANDO DE AVANZAR UN DÝA, PRIMERO SE COMPRUEBA QUE NO SE ESTÉ MOSTRANDO EL DÝA DE LA FECHA
            if (fechaActual.toLocaleDateString() != new Date().toLocaleDateString()) {
                fecha2 = new Date(fechaActual.setDate(fechaActual.getDate() + 1));
            } else {
                return null;
            }
        }

        let nuevaFecha = GlobalHelper.ConvertirFecha(fecha2.toLocaleDateString(), true, true);

        this.props.seleccionarFiltroProcesos('fecha', nuevaFecha);

        this.props.getTrazaProcesos(nuevaFecha, this.props.data.marcaId);
    }

    borrarFiltros() {
        this.props.seleccionarFiltroProcesos('fecha', new Date().toLocaleDateString());

        this.props.seleccionarFiltroProcesos('tipoProceso', '0');

        this.props.seleccionarFiltroProcesos('proceso', '0');

        this.props.seleccionarFiltroProcesos('marcaId', '0');

        this.props.getTrazaProcesos(new Date().toLocaleDateString(), '0'); //'0' - Valor para "Todos"
    }

    mostrarModal(modalId, abrirCerrar, params) {
        switch (modalId) {
            case 1: {
                //modal procesos documentados
                if (abrirCerrar == true) {
                    this.props.getProcesosDocumentados(params.marcaId);
                } else {
                    this.props.mostrarModal(1, abrirCerrar);
                }
                break;
            }
            case 2: {
                //modal ejecución a demanda
                this.props.mostrarModal(2, abrirCerrar);
                break;
            }
            case 3: {
                //modal proceso individual
                if (abrirCerrar == true) {
                    this.props.getDatosProceso(params.procesoTrazaId);
                }
                this.props.mostrarModal(3, abrirCerrar)
                if (abrirCerrar == false) {
                    this.props.getTrazaProcesos(this.props.data.fecha, this.props.data.marcaId);
                }
                break;
            }
            case 4: {
                //modal confirmar salir
                this.props.mostrarModal(4, abrirCerrar);
                break;
            }
            case 5: {
                //modal Proceso en ejecución
                this.props.mostrarModal(5, abrirCerrar);
                break;
            }
        }
    }

    validarFecha(fecha) {
        let fechaAux = fecha.split('/');
        let diaAux, mesAux, fechaFinal;

        if (fechaAux[0].length == 1) diaAux = '0' + fechaAux[0];
        else diaAux = fechaAux[0];

        if (fechaAux[1].length == 1) mesAux = '0' + fechaAux[1];
        else mesAux = fechaAux[1];

        fechaFinal = diaAux + '/' + mesAux + '/' + fechaAux[2];

        return fechaFinal;
    }

    obtenerDia(fecha) {
        let dia = "";
        let diaAux = fecha.split('/')[0];
        let mesAux = fecha.split('/')[1];
        let anioAux = fecha.split('/')[2];

        switch (new Date(mesAux + '/' + diaAux + '/' + anioAux).getDay()) {
            case 0:
                dia = "Domingo "
                break;
            case 1:
                dia = "Lunes "
                break;
            case 2:
                dia = "Martes "
                break;
            case 3:
                dia = "Miércoles "
                break;
            case 4:
                dia = "Jueves "
                break;
            case 5:
                dia = "Viernes "
                break;
            case 6:
                dia = "Sabado "
                break;
        }
        return dia;
    }

    render() {
        let { data } = this.props;
        let { ejecucionesProcesosFiltrados, procesosProgramados } = data;
        let fechaCalendario, fechaMostrar;
        const opcionesTipoProceso = [
            { Id: 'I', Descripcion: 'Archivos de entrada' },
            { Id: 'O', Descripcion: 'Archivos de salida' },
            { Id: 'P', Descripcion: 'Otros procesos' },
        ];
        let procesosPorAdministradora = [];
        let administradoraProcesosDocumentados = data.procesosDocumentados && data.procesosDocumentados.length > 0 ? data.procesosDocumentados[0].AdministradoraId : 1;

        let ejecAux = {
            admin1: {
                marcaId: 1,
                ejecuciones: [],
                esMarcaActiva: false,
            },
            admin2: {
                marcaId: 2,
                ejecuciones: [],
                esMarcaActiva: false,
            },
            admin3: {
                marcaId: 3,
                ejecuciones: [],
                esMarcaActiva: false,
            },
            admin4: {
                marcaId: null,
                ejecuciones: [],
                esMarcaActiva: true,
            }
        };
        //para que se renderee una columna para la administradora en el panel debe tener ejecuciones en el día o simplemente estar activa para poder ver los procesos documentados para la fecha
        if (data && data.administradoras) {
            if (data.administradorasFiltradas == undefined) data.administradorasFiltradas = data.administradoras;
            data.administradoras.map((marca) => {
                switch (marca.Id) {
                    case 1: {
                        ejecAux.admin1.esMarcaActiva = marca.Activo && data.administradorasFiltradas.some((adm) => adm.Id == 1);
                        break;
                    }

                    case 2: {
                        ejecAux.admin2.esMarcaActiva = marca.Activo && data.administradorasFiltradas.some((adm) => adm.Id == 2);
                        break;
                    }

                    case 3: {
                        ejecAux.admin3.esMarcaActiva = marca.Activo && data.administradorasFiltradas.some((adm) => adm.Id == 3);
                        break;
                    }

                }
            });
        }

        if (ejecucionesProcesosFiltrados && ejecucionesProcesosFiltrados.length > 0) {
            ejecucionesProcesosFiltrados.map((ejecucion) => {
                if (ejecucion.AdministradoraId == 1) ejecAux.admin1.esMarcaActiva && ejecAux.admin1.ejecuciones.push(ejecucion);
                if (ejecucion.AdministradoraId == 2) ejecAux.admin2.esMarcaActiva && ejecAux.admin2.ejecuciones.push(ejecucion);
                if (ejecucion.AdministradoraId == 3) ejecAux.admin3.esMarcaActiva && ejecAux.admin3.ejecuciones.push(ejecucion);
                if (ejecucion.AdministradoraId == null) ejecAux.admin4.ejecuciones.push(ejecucion);
            });

            Object.keys(ejecAux).forEach((key) => {
                if (ejecAux[key].ejecuciones.length > 0 || ejecAux[key].esMarcaActiva == true) procesosPorAdministradora.push(ejecAux[key]);
            });
        } else {
            Object.keys(ejecAux).forEach((key) => {
                if (ejecAux[key].esMarcaActiva == true) procesosPorAdministradora.push(ejecAux[key]);
            });
        }

        //Se quita la marca "Ninguna" en caso de seleccionar una marca en específica el filtro de Tablero de procesos - AD17-1553
        if (!isNaN(parseInt(data?.administradoraSeleccionada,10)) && parseInt(data?.administradoraSeleccionada,10) > 0) {
            procesosPorAdministradora = procesosPorAdministradora.filter(x => x.marcaId == parseInt(data?.administradoraSeleccionada,10));
        }

        //Validación para fecha que se muestra en el calendario
        if (typeof this.props.data.fecha == 'object') {
            fechaCalendario = this.props.data.fecha.toLocaleDateString();
            fechaCalendario = fechaCalendario.length <= 9 ? this.validarFecha(fechaCalendario) : fechaCalendario;
        } else if (typeof this.props.data.fecha == 'string' && this.props.data.fecha.length > 10) {
            fechaCalendario = new Date().toLocaleDateString();
            fechaCalendario = fechaCalendario.length <= 9 ? this.validarFecha(fechaCalendario) : fechaCalendario;
        } else if (typeof this.props.data.fecha == 'string') {
            fechaCalendario = this.props.data.fecha;
            fechaCalendario = fechaCalendario.length <= 9 ? this.validarFecha(fechaCalendario) : fechaCalendario;
        }

        fechaMostrar = this.obtenerDia(fechaCalendario) + fechaCalendario;

        let classInputFecha = {className: "form-control " + (data.mostrarTablero ? "form-control-tarjetas" : "botonMenuProcesos--disabled")}

        return (
            <div className="container-fluid tarjetas">
                {data.modalProcesoEnEjecucion &&
                    <ModalEjecucionEnProcesos mostrarModal={this.mostrarModal}
                        nombreProceso={data.nombreProceso}
                        mensaje={data.mensaje} />}

                {data.modalProcesoIndividual && data.datosProcesosEncabezado &&
                    <ModalProcesos limpiarTablero={this.props.limpiarTablero}
                        validarProcesoEnEjecucion={this.props.validarProcesoEnEjecucion}
                        datosProcesos={data.datosProcesos}
                        datosProcesosEncabezado={data.datosProcesosEncabezado}
                        datosProceso={data.datosProceso}
                        mostrarModal={this.mostrarModal}
                        administradora={data.datosProcesosEncabezado.AdministradoraId}
                        proceso={data.datosProcesosEncabezado}
                        getErroresProceso={this.props.getErroresProceso}
                        descargarExcel={this.props.descargarExcel} />}

                {data.modalProcesosDocumentados &&
                    <ModalProcesosDocumentados mostrarModal={this.mostrarModal}
                        administradora={administradoraProcesosDocumentados}
                        procesos={data.procesosDocumentados} />}

                {data.modalEjecucionDemanda &&
                    <ModalEjecucionDemanda idsProcesamiento={data.idsProcesamiento}
                        funcionSeleccion={this.props.actualizarIDProcesamiento}
                        seleccionArchivo={this.props.seleccionArchivo}
                        limpiarCombos={this.limpiarCombos}
                        seleccionComboEjecucionDemanda={this.props.seleccionComboEjecucionDemanda}
                        procesos={data.procesos} marcas={data.administradoras}
                        tiposProceso={opcionesTipoProceso}
                        mostrarModal={this.mostrarModal}
                        seleccionIdProceso={this.props.seleccionIdProceso}
                        data={data}
                        ejecutarDtsx={this.props.ejecutarDtsx}
                        valorActualCombos={data.combosEjecucionDemanda}
                        administradoraIdSeleccionada={data.marcaIdEjecucion}
                        addArchivoEjecucionDemanda={this.props.addArchivoEjecucionDemanda}
                        errorArchivoEjecDemanda={data.errorArchivoEjecDemanda}
                        setBusquedaArchivos={this.props.setBusquedaArchivos} 
                        mostrarTablero={data.mostrarTablero} />}

                {data && data.loadingEjecDemanda && <div id="loading" className="loading" />}

                {data && data.loadingTablero && <div id="loading" className="loading" />}

                {data.modalMensajeResultado != "" ?
                    <ModalMensajeResultado
                        mostrarOcultarModal={this.props.mostrarOcultarModal}
                        mensaje={data.modalMensajeResultado}
                    />
                :
                    null
                }
                <div className={'row barraMenuProcesos ' + (!data.mostrarTablero ? "disableDiv Procesos__seccionFiltrosFechas--disabled" : "")}>
                    <div className="col-md-9 noPaddingLeft">
                        <div className="row lineMenuProcesos">
                            <div className="col-md-12 ">
                                <div className="firaTitulo ">Tablero de ejecución procesos</div>
                            </div>
                        </div>

                        <div className="CuentaSeleccionContainer tableroProcesosPanelSuperior">
                            <div className="CuentaSeleccionContainer">
                                <div>
                                    <SelectorFecha
                                        maxToday={true}
                                        claseContainer={"Procesos__seccionFiltrosFechasSuperiores Procesos__seccionFiltrosFechas Procesos--floatLeft Procesos__fechaDesdeMargin"}
                                        fecha={fechaCalendario}
                                        fArguments={['fecha']}
                                        funcionSeleccion={this.props.seleccionarFiltroProcesos}
                                        errorFormatoFecha={data.errorFormatoFecha}
                                        inputProps={classInputFecha}
                                    />
                                    {data && (data.errorFormatoFecha || data.esFechaPosterior) && <label className="error">{data.msjErrorCalendario}</label>}
                                </div>
                                {data && data.administradoras && (
                                    <div className="left-separator-xs">
                                        <ComboMenuProcesos
                                            titulo={'Marca'}
                                            placeholder={'Todos'}
                                            nombreAction={'marcaId'}
                                            selecciones={data}
                                            selectCombo={this.props.seleccionarFiltroProcesos}
                                            infoData={data.administradoras}
                                            mostrarTablero={data.mostrarTablero}
                                        />
                                    </div>
                                )}
                                <div className="left-separator-xs">
                                    <ComboMenuProcesos
                                        titulo={'Tipo de Proceso'}
                                        placeholder={'Todos'}
                                        nombreAction={'tipoProceso'}
                                        selecciones={data}
                                        selectCombo={this.props.seleccionarFiltroProcesos}
                                        infoData={opcionesTipoProceso}
                                        mostrarTablero={data.mostrarTablero}
                                    />
                                </div>
                                <div className="left-separator-xs">
                                    <ComboMenuProcesos
                                        titulo={'Proceso'}
                                        placeholder={'Todos'}
                                        nombreAction={'proceso'}
                                        selecciones={data}
                                        selectCombo={this.props.seleccionarFiltroProcesos}
                                        infoData={data.procesosFiltrado}
                                        mostrarTablero={data.mostrarTablero}
                                    />
                                </div>
                            </div>
                            <button
                                ref={(buttonDOM) => {
                                    this.buttonDOM = buttonDOM;
                                }}
                                data-toggle="tooltip"
                                data-title="Limpiar filtros."
                                data-placement="right"
                                className={"botonEliminarFiltroProcesos left-separator-xs " + (data.mostrarTablero ? "" : "botonEliminarFiltroProcesos--disabled")}
                                onClick={() => {
                                    this.borrarFiltros();
                                    this.buttonDOM.blur();
                                }}></button>
                        </div>
                    </div>

                    <div className="col-md-3 lineMenuProcesos noPaddingRight">
                        <button className={"botonMenuProcesos separadorBotonesProcesos" + (data.mostrarTablero ? "" : " botonMenuProcesos--disabled")} onClick={() => data.mostrarTablero ? this.props.validarProcesoEnEjecucion(false) : null}>
                            Ejecución a demanda
                        </button>
                        <button className={"botonMenuProcesos" + (data.mostrarTablero ? "" : " botonMenuProcesos--disabled")} onClick={() => data.mostrarTablero ? this.props.getTrazaProcesos(fechaCalendario, data.marcaId) : null}>
                            Ver
                        </button>
                    </div>
                </div>
                <div className={'row ' + (!data.mostrarTablero ? 'disableDiv Procesos__seccionFiltrosFechas--disabled' : '')}>
                    <div className="barSeparatorProcesos col-md-12 procesoColumnRight">
                        <div className={data.mostrarTablero ? "flechaBarraProcesos" : "flechaBarraProcesos--disabled"} onClick={() => this.cambiarDiaPorFlecha('anterior')}>
                            ❮
                        </div>

                        <div className="fechaSeparadorProcesos">{fechaMostrar}</div>
                        
                        <div className={data.mostrarTablero ? "flechaBarraProcesos" : "flechaBarraProcesos--disabled"} onClick={() => this.cambiarDiaPorFlecha('posterior')}>
                            ❯
                        </div>
                    </div>
                </div>
                {data.mostrarTablero ? (
                    <TableroProcesos fecha={fechaCalendario} procesosProgramados={procesosProgramados} loadingEjecDemanda={data.loadingEjecDemanda} mostrarModal={this.mostrarModal} procesosPorAdministradora={procesosPorAdministradora} />
                ) : (
                    <DetalleErrores
                        validarProcesoEnEjecucion={this.props.validarProcesoEnEjecucion}
                        RecorrerTabla={this.RecorrerTabla}
                        seleccionarTabError={this.props.seleccionarTabError}
                        mostrarModal={this.mostrarModal}
                        checkAllError={this.props.checkAllError}
                        checkError={this.props.checkError}
                        data={data}
                        getErroresProceso={this.props.getErroresProceso}
                        /**
                         * ADT-1220
                         * Adintar17 - Tablero de ejecuciones: No se reprocesa correctamente el archivo cuando se desestiman los registros
                         * Segun hablado con Silvia Serra para reprocesar, se debe por lo menos seleccionar un registro a reprocesar,
                         * si desestima todo debe mostrar una advertencia indicando que por lo menos debe seleccionar un registro a reprocesar
                         * para efectuar la accion de Reprocesar
                         */
                        ocultarModalDatosCuenta={this.props.ocultarModalDatosCuenta}
                        DescargarExcelErroresYNotas={this.props.DescargarExcelErroresYNotas}
                    />
                )}
            </div>
        );
    }
}

export default Procesos;
